export default function About() {
  return (
    <section id="about" className="relative py-32 px-6 bg-gradient-to-r from-red-950/20 to-black">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-5 gap-12 items-center">
          {/* Left Column - Image */}
          <div className="md:col-span-2">
            <div className="relative">
              <div className="absolute inset-0 bg-red-600/20 rounded-3xl blur-2xl"></div>
              <div className="relative rounded-3xl overflow-hidden border-3 border-red-600/50 shadow-2xl shadow-red-600/30">
                <img 
                  src="https://static.readdy.ai/image/784caf738992fff872ad90f0e356a90f/5c5e77e69d62761e5edfbf7a7df315f4.jpeg"
                  alt="Thomas - French Comedian Mentalist Magician"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>

          {/* Right Column - Content */}
          <div className="md:col-span-3">
            <div className="mb-6">
              <span className="text-red-600 text-xs font-bold uppercase tracking-wider">About the Artist</span>
            </div>
            
            <h2 className="text-6xl md:text-7xl font-bold text-white mb-10" style={{ fontFamily: 'Playfair Display, serif' }}>
              Thomas is French
            </h2>
            
            <div className="space-y-8">
              <p className="text-gray-300 text-lg leading-relaxed">
                <strong className="text-white">Thomas is French</strong> was born in <strong className="text-red-400">Paris</strong> and raised in Bermuda. His interest in <strong className="text-red-400">magic</strong> began after watching The Illusionist and The Prestige, which led him to start performing at a young age. At 12, he was booked for his first paid show, and soon after performed in schools and on the streets of Paris. While studying filmmaking, he continued performing and worked on film sets, coaching actors and serving as a hand double for magic scenes.
              </p>
              
              <p className="text-gray-300 text-lg leading-relaxed">
                His career later developed internationally, performing in English, French, and Spanish across France, Spain, Italy, the UK, Dubai, Vietnam, Thailand, Malaysia, Indonesia, and Japan. He has appeared in <strong className="text-red-400">comedy clubs</strong>, universities, theaters, and festivals, including the Edinburgh Fringe, and has produced several shows. Thomas is on a mission to bring his magic to as many countries and cultures across the globe.
              </p>
            </div>
            
            <div className="mt-10">
              <div className="w-20 h-0.5 bg-red-600"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}